import * as types from 'actions/types';
import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  activeId: null,
};

const chatAlertActive = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CHAT_ALERT_ACTIVE_ID:
      return dotProp.set(state, 'activeId', action.activeId);
    default:
      return state;
  }
};

export default chatAlertActive;
